import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const FAQS = [
  {
    q: "Do I need to be fit before I start?",
    a: "No. There's no fitness requirement to join — coaches scale every workout to your current level and build you up from there.",
  },
  {
    q: "I've never done functional fitness before. Can I still join?",
    a: "Yes. Every class is coached and every movement is taught from the ground up. Most of our members walked in as complete beginners.",
  },
  {
    q: "What should I bring to my first session?",
    a: "Just comfortable training clothes, trainers, and water. We'll take care of the rest — no equipment or experience required.",
  },
  {
    q: "How long are the classes?",
    a: "Most coached sessions run for an hour, start to finish — warm-up, coached skill or strength work, then the workout itself.",
  },
  {
    q: "Do you offer a free trial?",
    a: "Yes — every newcomer gets a free, fully coached session before committing to anything. Book yours below.",
  },
];

export function FAQSection() {
  return (
    <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32" data-testid="faq-section">
      <Reveal className="text-center mb-12">
        <p className="font-accent italic text-gold text-lg mb-3">Good to know</p>
        <h2 className="font-anton uppercase tracking-tighter text-cream text-4xl sm:text-5xl">Your questions, answered.</h2>
        <p className="text-smoke mt-4">
          Starting something new should feel exciting, not uncertain. Here are the answers to our
          most common questions.
        </p>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="border-t border-line">
          {FAQS.map((item, i) => (
            <AccordionItem key={item.q} value={`faq-${i}`} className="border-b border-line" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-cream font-semibold text-left hover:text-gold py-5">{item.q}</AccordionTrigger>
              <AccordionContent className="text-smoke leading-relaxed">{item.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
